// extracted by mini-css-extract-plugin
module.exports = {"requestContainer":"ReviewerActiveRequests_requestContainer__KLA_G","column":"ReviewerActiveRequests_column__5_FZZ"};